export const computeScore = (term: string, diagnosis: string, total: number) => {
  const words = (term || '')
    .toLowerCase()
    .split(' ')
    .filter(d => !!d.trim());
  let score = 0;
  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    const index = diagnosis.toLowerCase().indexOf(word);
    if (index < 0) {
      score += total;
    } else {
      score += index;
    }
  }
  return score;
};

export const mapElasticHits = (results: any, term: string, total: number): any[] => {
  let diags = results.hits.hits.map((hit: any) => ({
    id: hit._id,
    name: hit._source.diagnosis_name,
    code: hit._source.diagnosis_code,
    score1: hit._score
  }));
  diags = diags.map((item: any) => ({
    ...item,
    name: item.name,
    score2: computeScore(term, item.name, total)
  }));
  return diags;
};

export const mapElasticHitsMedication = (results: any, term: string, total: number): any[] => {
  let meds = results.hits.hits.map((hit: any) => ({
    id: hit._id,
    generic_name: hit._source.generic_description,
    generic_description_code: hit._source.generic_description_code,
    brand_name: hit._source.generic_name,
    package_code: hit._source.package_code,
    strength: hit._source.strength,
    strength_code: hit._source.strength_code,
    salt: hit._source.salt,
    salt_code: hit._source.salt_code,
    form: hit._source.form,
    form_code: hit._source.form_code,
    code: hit._source.code,
    unit: hit._source.amount,
    unit_code: hit._source.amount_code,
    category: hit._source.category
  }));
  meds = meds.map((item: any) => ({
    ...item,
    name: item.brand_name
  }));
  return meds;
};
